import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import users from '../assets/img/svg/users.svg'

import user from '../assets/img/user-6.jpg'

import { featureProperty } from '../data/property'
import toast from 'react-hot-toast'
import validator from 'validator';
import { sendMsg } from '../services/ApiServices'

export default function DetailSidebar({ spaceDetails }: any) {
    const initialState = {
        email: "",
        phoneno: "",
        message: ""
    }
    const [isOpenShareModal, setOpenShareModal] = useState<boolean>(false);
    const [isCopied, setCopied] = useState<boolean>(false);
    const [salePrice, setSalePrice] = useState("");
    const [downPayment, setDownPayment] = useState("");
    const [loanTerm, setLoanTerm] = useState("");
    const [interestRate, setInterestRate] = useState("");
    const [monthlyPayment, setMonthlyPayment] = useState<any>(null);
    const [interestAmount, setInterestAmount] = useState<any>("");
    const [sendMsgData, setSendMsgData] = useState<any>(initialState);
    const [isProcessing, setProcessing] = useState<boolean>(false);
    const [isOpenSendMsgModal, setOpenSendMsgModal] = useState<boolean>(false);

    console.log("monthlyPayment", monthlyPayment);

    const calculateMortgage = (e: any) => {
        e.preventDefault();

        const principal = parseFloat(salePrice) - parseFloat(downPayment);
        const monthlyInterestRate = parseFloat(interestRate) / 12 / 100;
        const numberOfPayments = parseFloat(loanTerm) * 12;

        if (principal > 0 && monthlyInterestRate > 0 && numberOfPayments > 0) {
            const monthly: any =
                (principal *
                    monthlyInterestRate *
                    Math.pow(1 + monthlyInterestRate, numberOfPayments)) /
                (Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1);

            setMonthlyPayment(monthly.toFixed(2)); // Display with 2 decimal points
            setInterestAmount((monthly.toFixed(2) * numberOfPayments - principal).toFixed(2))
        } else {
            setMonthlyPayment("Invalid input");
        }
    };

    const textAreaRef: any = useRef(null);
    const handleCopy = () => {
        navigator.clipboard.writeText(`${window.location.origin}/property-details/${spaceDetails?.id}`).then(
            () => {
                console.log("asdfsnfdsf");
                setCopied(true)
            },
            (err) => {
                console.error("Failed to copy: ", err);
            }
        );
    };

    const handleSendMsg = (e: any) => {
        setSendMsgData({ ...sendMsgData, [e.target.name]: e.target.value })
    }

    const validation = (e: any) => {
        e.preventDefault();
        if (!sendMsgData?.email) {
            toast.error("Please enter your email");
            return;
        }
        if (sendMsgData?.email && !validator.isEmail(sendMsgData?.email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        if (!sendMsgData?.phoneno) {
            toast.error("Please enter your phone number");
            return;
        }
        if (!sendMsgData?.message) {
            toast.error("Please enter your message");
            return;
        }
        sendMsgApiCall()
    }

    const sendMsgApiCall = () => {
        setProcessing(true);
        const requestBody: any = {
            email: sendMsgData?.email,
            phoneno: sendMsgData?.phoneno,
            message: `${sendMsgData?.message}<br><br> Property Link: https://commercialspc.com/property-details/${spaceDetails?.id}`,
            client_email: spaceDetails?.user_email,

        }
        sendMsg(requestBody).then((res) => {
            console.log("contact us", res);
            if (res?.validaterror === "1") {
                toast.error(res?.message)
                setProcessing(false)
                return;
            } else {
                setOpenSendMsgModal(true);
                // toast.success(res?.message)
                setSendMsgData(initialState)
                setProcessing(false)
            }
        }).catch((err) => {
            console.log("add space error", err);
        })
    }

    return (
        <>
            <div className="like_share_wrap b-0">
                <ul className="like_share_list">
                    <li>
                        <Link
                            to="#"
                            className="btn "
                            data-toggle="tooltip"
                            data-original-title="Share"
                            onClick={() => setOpenShareModal(true)}
                        >
                            <i className="fas fa-share"></i>Share
                        </Link>
                    </li>
                </ul>
            </div>


            <div className="details-sidebar">
                <div className="sides-widget">
                    <div className="sides-widget-header bg-primary">
                        <div className="agent-photo"><span className="svg-icon svg-icon-2hx me-1">
                            <svg width="44" height="44" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor" />
                                <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor" />
                                <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor" />
                            </svg>
                        </span></div>
                        <div className="sides-widget-details">
                            <h4><Link to="#">{spaceDetails?.user_name}</Link></h4>
                            <span>{spaceDetails?.user_email}</span>
                        </div>
                        <div className="clearfix"></div>
                    </div>

                    <div className="sides-widget-body simple-form">
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Your Email"
                                value={sendMsgData?.email}
                                name='email'
                                onChange={handleSendMsg}
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone No.</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Your Phone"
                                value={sendMsgData?.phoneno}
                                name='phoneno'
                                onChange={handleSendMsg}
                            />
                        </div>
                        <div className="form-group">
                            <label>Description</label>
                            <textarea
                                className="form-control"
                                value={sendMsgData?.message}
                                name='message'
                                onChange={handleSendMsg}
                            > </textarea>
                        </div>
                        <button
                            className="btn btn-light-primary fw-medium rounded full-width"
                            onClick={(e) => validation(e)}
                            disabled={isProcessing}
                        >
                            Send Message
                        </button>
                    </div>
                </div>

                <div className="sides-widget">

                    <div className="sides-widget-header bg-primary">
                        <div className="sides-widget-details">
                            <h4>Mortgage Calculator</h4>
                        </div>
                        <div className="clearfix"></div>
                    </div>

                    <div className="sides-widget-body simple-form">
                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="text" className="form-control" placeholder="Sale Price" value={salePrice}
                                    onChange={(e) => setSalePrice(e.target.value)} />
                                <i className="fa-solid fa-sack-dollar"></i>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="text" className="form-control" placeholder="Down Payment" value={downPayment}
                                    onChange={(e) => setDownPayment(e.target.value)} />
                                <i className="fa-solid fa-piggy-bank"></i>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="text" className="form-control" placeholder="Loan Term (Years)" value={loanTerm}
                                    onChange={(e) => setLoanTerm(e.target.value)} />
                                <i className="fa-regular fa-calendar-days"></i>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="input-with-icon">
                                <input type="text" className="form-control" placeholder="Interest Rate" value={interestRate}
                                    onChange={(e) => setInterestRate(e.target.value)} />
                                <i className="fa fa-percent"></i>
                            </div>
                            {/* Kunjal1412 */}
                        </div>
                        <button className="btn btn-light-primary fw-medium rounded full-width" onClick={(e) => calculateMortgage(e)}>Calculate</button>
                        {monthlyPayment && <h4 className="property_block_title mt-2" style={{ fontSize: 17 }}>Monthly Payment = {monthlyPayment}</h4>}
                        {interestAmount && <h4 className="property_block_title" style={{ fontSize: 17 }}>Total Interest Paid = {interestAmount}</h4>}
                    </div>
                </div>
                {
                    isOpenShareModal &&
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                        <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                            <div className="modal-content" id="registermodal">
                                <span className="mod-close" onClick={() => setOpenShareModal(!isOpenShareModal)}>
                                    <span className="svg-icon text-primary svg-icon-2hx">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                            <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                            <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                        </svg>
                                    </span>
                                </span>
                                <div className="modal-body">
                                    <div className="text-center">
                                        <div style={{ padding: 10, borderRadius: 5, backgroundColor: "#eeeeee", marginTop: 10, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <span >{`${window.location.origin}/property-details/${spaceDetails?.id}`}</span>
                                            <button onClick={handleCopy} className='btn bg-primary' style={{ color: "#fff" }}>
                                                {isCopied ? "Copied" : "Copy"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    isOpenSendMsgModal &&
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                        <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                            <div className="modal-content" id="registermodal">
                                <span className="mod-close" onClick={() => setOpenSendMsgModal(!isOpenSendMsgModal)}>
                                    <span className="svg-icon text-primary svg-icon-2hx">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                            <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                            <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                        </svg>
                                    </span>
                                </span>
                                <div className="modal-body">
                                    <h4 className="modal-header-title" style={{ fontSize: 25 }}>Sent Message</h4>
                                    <div className="d-flex align-items-center justify-content-center mb-3">
                                        <span>Thank you. Your message has been sent</span>
                                    </div>
                                    <div className="form-group d-flex">
                                        <button type="button" className="btn btn-md btn-primary fw-medium full-width rounded-2" onClick={() => setOpenSendMsgModal(false)}>Ok</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </>
    )
}